var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSwitchUserDialogOpen)?_c('ag-modal-container',{attrs:{"title":"Changer d'utilisateur","width":"500px","no-content-padding":""},on:{"close":_vm.close}},[_c('login-form',{attrs:{"loading":_vm.loading},on:{"send":_vm.callLoading}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }